// This file is the entry point for browser bundles

import { Client } from "../browser/Client.js";
import { getDefaultClient, setDefaultClient } from "../Client.js";
import { DataHandler, DataProviderHandler, DataProviderHandlerAPI, SortOrder } from "../DataHandler.js";
import { DataObject } from "../DataObject.js";
import { FileUploader } from "../FileUploader.js";
import { generateApiDataHandler, generateApiDataObject } from "../generateApiDataObject.js";
import { Paging } from "../Paging.js";
import { Procedure, ProcedureAPI } from "../Procedure.js";
import { MemoryStorage, uid } from "../Storage.js";
import { UploadManager } from "../upload/UploadManager.js";
import { UploadTask } from "../upload/UploadTask.js";

export {
	Client,
	DataObject,
	DataHandler,
	DataProviderHandlerAPI,
	DataProviderHandler,
	FileUploader,
	generateApiDataHandler,
	generateApiDataObject,
	getDefaultClient,
	setDefaultClient,
	MemoryStorage,
	Paging,
	Procedure,
	ProcedureAPI,
	SortOrder,
	uid,
	UploadManager,
	UploadTask,
};

export const version = __VERSION__;
